// File generated by Telosys Tools Generator ( version 3.3.0 ) - Date 2022-03-02 ( Time 15:04:23 )

import {Clients} from './clients.model';

export class Historique {
	id: number; // Wrapper Type : Number
	date: string; // Wrapper Type : Date
	action: string; // Wrapper Type : String
  clientId: Clients; // Wrapper Type : Number
}
